var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaiseBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_9",
    "data-name": "Calque 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 532 1361.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#353535;}.cls-4{fill:#161616;}.cls-5{fill:#636363;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-770 -391)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293,790l-48-31c-4.06-2-7-2-13-2h-17V641c26.13-7.59,42.58-23.92,46-52l1-159c-7.59-24-22.87-37.54-47-39l-179,6-179-6c-24.13,1.46-39.41,15-47,39l1,159c3.42,28.08,19.87,44.41,46,52V757H840c-6,0-8.94,0-13,2l-48,31c-5.25,3.59-7.78,8.48-9,14v32c2.3,8.51,8.1,10.74,15,11h19l10,901c12.17,7,21.93,5.69,35,0l-2-370h20l4,175c9.35,6,20.37,4.45,32,0l-2-176h135l135,1-2,175c11.63,4.45,22.65,6,32,0l4-175h20l-1,370c13.07,5.69,21.83,7,34,0l10-901h19c6.9-.26,12.7-2.49,15-11V804C1300.78,798.48,1298.25,793.59,1293,790ZM846,1359l-2-437h16l8,437Zm326,0H900l-4-113h280Zm4-126H896l-3-311h286Zm4-478-144-1-144,1-1-112c45.36,1.39,93.92,1.65,145,1,51.08.65,99.64.39,145-1Zm46,604h-22l8-437h16Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "r\xE9paration vmc mauvaise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1293,790l-48-31c-4.06-2-7-2-13-2h-17V641c26.13-7.59,42.58-23.92,46-52l1-159c-7.59-24-22.87-37.54-47-39l-179,6-179-6c-24.13,1.46-39.41,15-47,39l1,159c3.42,28.08,19.87,44.41,46,52V757H840c-6,0-8.94,0-13,2l-48,31c-5.25,3.59-7.78,8.48-9,14v32c2.3,8.51,8.1,10.74,15,11h19l10,901c12.17,7,21.93,5.69,35,0l-2-370h20l4,175c9.35,6,20.37,4.45,32,0l-2-176h135l135,1-2,175c11.63,4.45,22.65,6,32,0l4-175h20l-1,370c13.07,5.69,21.83,7,34,0l10-901h19c6.9-.26,12.7-2.49,15-11V804C1300.78,798.48,1298.25,793.59,1293,790ZM846,1359l-2-437h16l8,437Zm326,0H900l-4-113h280Zm4-126H896l-3-311h286Zm4-478-144-1-144,1-1-112c45.36,1.39,93.92,1.65,145,1,51.08.65,99.64.39,145-1Zm46,604h-22l8-437h16Z",
    transform: "translate(-770 -391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M857,641c12.91,1.57,24.91,2.63,34,2l137,10,153-10c14.75-.2,28.28-.56,34-2V757l3,7h-54c-2,0-9-17-9-17l-260,3-2,11-61,1Z",
    transform: "translate(-770 -391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M778,798c-16,0,42-41,51-42,4,.85,30,2,66-1,73.41-.17,194.08-2.13,285,0,13.11,1.64,24.46,1.48,35,2,8.76.43,25-6.36,33-6,0,0,55,45,47,48S778,798,778,798Z",
    transform: "translate(-770 -391)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 74,
    y: 455,
    width: 384,
    height: 76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "90 531 98 968 434 968 446 507 90 531"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "96 987 131 986 446 987 434 1200 98 1162 96 987"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaiseBar);
export default __webpack_public_path__ + "static/media/chaise_bar.a7c6dadb198143e75af42855ce48d716.svg";
export { ForwardRef as ReactComponent };